const handleValidation = (state, fields) => {
  state = typeof state === 'undefined' ? {} : state;
  const validate = {};
  fields.map(field => {
    if (typeof state[field] === 'undefined' || !state[field]) {
      validate[field] = {
        error: true,
        message: `Field can't be empty!!`,
      };
    } else if (
      (field === 'DestinationCountry' || field === 'AdditionalServiceType') &&
      state[field] &&
      state[field].Value === ''
    ) {
      validate[field] = {
        error: true,
        message: `Field can't be empty!!`,
      };
    } else {
      delete validate[field];
    }
    return validate;
  });

  return validate;
};

export default handleValidation;
